import React from 'react';
import PropTypes from 'prop-types';

import './table.css';

class Table extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sortColumn: -1,
            sortDesc: !!props.defaultSortDesc
        };

        this.renderHeader = this.renderHeader.bind(this);
        this.renderDataRow = this.renderDataRow.bind(this);
        this.sort = this.sort.bind(this);
        this.renderSortIcon = this.renderSortIcon.bind(this);
    }

    componentDidMount() {
        const { data, defaultSortColumn, columns } = this.props;
        this.setState({ data }, () => {
            if (defaultSortColumn !== undefined) {
                this.sort(columns[defaultSortColumn], defaultSortColumn);
            }
        });
    }

    UNSAFE_componentWillReceiveProps(props) {
        const { data, columns } = props;
        const { sortColumn, sortDesc } = this.state;
        if (sortColumn > -1) {
            const sort = columns[sortColumn].sort;
            const descSort = (a, b) => sort(b, a);
            const comparer = !sortDesc ? sort : columns[sortColumn].descSort || descSort;
            const sorted = [...data.sort(comparer)];
            this.setState({ data: sorted });
            return;
        }

        this.setState({ data });
    }

    sort(column, columnIndex) {
        if (!column.sort) {
            return;
        }

        const { data, sortColumn, sortDesc } = this.state;
        const { defaultSortColumn, defaultSortDesc } = this.props;
        const sort = column.sort;

        const nextSortDesc = (columnIndex === sortColumn && !sortDesc) || (columnIndex !== sortColumn && columnIndex === defaultSortColumn && defaultSortDesc);
        const descSort = column.descSort || ((a, b) => sort(b, a));
        const sorted = [...data.sort(nextSortDesc ? descSort : sort)];

        this.setState({ sortColumn: columnIndex, sortDesc: nextSortDesc, data: sorted });
    }

    renderSortIcon(comparer, columnIndex) {
        if (!comparer) {
            return null;
        }

        const { sortColumn, sortDesc } = this.state;

        if (columnIndex !== sortColumn) {
            return <i className="material-icons">unfold_more</i>;
        }

        return <i className="material-icons"> {sortDesc ? 'expand_less' : 'expand_more'} </i>;
    }

    renderHeader() {
        const { columns } = this.props;
        if (columns.filter(c => c.label).length <= 0) {
            return null;
        }

        const sortClass = c => (c.sort ? 'clickable' : '');
        const justifyClass = c => (c.justify === 'right' ? 'pull-right' : '');

        return (
            <div className="row gl-table-header">
                {columns.map((column, i) => (
                    <div key={i} className={`${column.size} ${sortClass(column)} gl-table-header-column`} onClick={() => this.sort(column, i)}>
                        <div className={justifyClass(column)}>
                            {column.label} {this.renderSortIcon(column.sort, i)}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    renderDataRow(row, i) {
        const { columns, rowStyle, keyExtractor } = this.props;
        const rowKey = keyExtractor ? row[keyExtractor] : i;
        return (
            <div key={rowKey} className={`row ${rowStyle}`}>
                {columns.map((column, j) => (
                    <div key={`${rowKey}-${j}`} className={`${column.size} gl-table-body-column ${column.bold === true ? 'table-strong' : 'table-small'}`}>
                        {column.valueMap(row)}
                    </div>
                ))}
            </div>
        );
    }

    render() {
        const { columns } = this.props;
        const { data } = this.state;

        if (!columns || columns.length === 0) {
            return null;
        }

        return (
            <div className="row gl-table">
                <div className="col-xs-12">
                    {this.renderHeader()}
                    {data && data.length > 0 ? data.map((row, i) => this.renderDataRow(row, i)) : null}
                </div>
            </div>
        );
    }
}

Table.defaultProps = {
    data: undefined,
    columns: undefined,
    rowStyle: 'gl-table-body-row',
    defaultSortColumn: undefined,
    defaultSortDesc: undefined,
    keyExtractor: undefined
};

Table.propTypes = {
    data: PropTypes.array,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.any,
            size: PropTypes.string,
            bold: PropTypes.bool,
            valueMap: PropTypes.func.isRequired,
            sort: PropTypes.func,
            descSort: PropTypes.func
        })
    ),
    rowStyle: PropTypes.string,
    defaultSortColumn: PropTypes.number,
    defaultSortDesc: PropTypes.bool,
    keyExtractor: PropTypes.any
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/table/index.jsx